import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'of-not-found-page',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  template: `
    <div class="page">
      <mat-card class="card">
        <h2>Not Found</h2>
      </mat-card>
    </div>
  `,
})
export class NotFoundPage {}
